import { fetcher } from '@commenda/utils';
import type { AdminPylonAccountSummary } from './useAdminCompanyExternalConnections';

export interface GetAdminPylonAccountParams {
  accountId: string;
}

export async function getAdminPylonAccount({
  accountId,
}: GetAdminPylonAccountParams): Promise<AdminPylonAccountSummary> {
  const response = await fetcher(
    `admin/external-connections/pylon/accounts/${accountId}`,
    { method: 'GET' }
  );

  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as {
      message?: unknown;
      error?: unknown;
    } | null;
    const message =
      typeof body?.message === 'string'
        ? body.message
        : Array.isArray(body?.message)
          ? body.message.join(', ')
          : typeof body?.error === 'string'
            ? body.error
            : 'Failed to load Pylon account';
    throw new Error(message);
  }

  return response.json();
}
